import { z } from 'zod';

/** Date et heure ISO 8601 avec fuseau (par exemple 2026-10-17T08:00:00Z), transmise en texte. */
export const schemaDateHeure = z.iso.datetime({ offset: true, message: 'Date et heure ISO 8601 attendue' });
